<template>
  <div class="m-userinfo-dialog" v-loading="loading">
    <div class="container">
      <div class="anonymous" v-if="isMine && editing === false">
        <el-avatar icon="el-icon-user" :src="info.amAvatarUrl"></el-avatar>
        <div class="text">
          <p>
            <span>昵称</span>
            <span>【匿名】{{ nickName }}</span>
          </p>
          <p>
            <span>性别</span>
            <span v-if="sex === 1">男</span>
            <span v-else-if="sex === 2">女</span>
            <span v-else>未设置</span>
          </p>
        </div>
        <span class="right edit-btn" @click="editing = true">修改</span>
      </div>
      <div class="anonymous editing" v-if="isMine && editing === true">
        <el-avatar icon="el-icon-user" :src="info.amAvatarUrl"></el-avatar>
        <div class="text">
          <p>
            <span>昵称</span>
            <span>【匿名】<input type="text" v-model="nickName"/></span>
          </p>
          <p>
            <span>性别</span>
            <span>
              <el-checkbox :value="sex === 1" @change="setSex(1)" label="男"></el-checkbox>
              <el-checkbox :value="sex === 2" @change="setSex(2)" label="女"></el-checkbox>
            </span>
          </p>
        </div>
        <span class="right edit-btn" @click="save">完成</span>
      </div>
      <template v-if="isAnonymous === false || isMine">
        <div class="real">
          <el-avatar icon="el-icon-user" :src="info.avatar"></el-avatar>
          <div class="text">
            <p>
              <span>昵称</span>
              <span>{{ info.name }}</span>
            </p>
            <p v-if="isMine" class="text-btn" @click="$router.push('/wallet')">我的钱包>></p>
          </div>
          <el-button class="right" v-if="!isMine" @click="privateChat" type="primary" size="mini">私聊</el-button>
          <el-divider></el-divider>
        </div>
        <div class="company">
          <p class="name">{{ companyInfo.companyName }}</p>
          <p>
            <span>电话</span>
            <span>
              <span v-for="(item, index) in companyInfo.contacts" :key="index">
                {{ item.number }}
              </span>
            </span>
          </p>
          <p>
            <span>地址</span>
            <span>{{ companyInfo.address }}</span>
          </p>
        </div>
        <div class="tags-box" v-if="!isMine">
          <p>客户给TA贴的标签 <span>(橙色为我给TA贴的)</span></p>
          <template v-if="companyInfo.labels.length || companyInfo.otherLabels.length">
            <div class="green-tags">
              <span class="tag" v-for="(item, index) in companyInfo.labels" :key="index">{{ item.label }}({{ item.qty }})</span>
            </div>
            <div class="orange-tags">
              <span class="tag" v-for="(item, index) in companyInfo.otherLabels" :key="index">{{ item.label }}({{ item.qty }})</span>
            </div>
          </template>
          <p v-else>
            <span v-if="companyInfo.isHideLabel">此供应商选择了隐藏标签</span>
            <span class="empty-text" v-else>暂无标签</span>
          </p>
        </div>
        <div class="more">
          <span class="text-btn" @click="link">查看更多>></span>
        </div>
      </template>
      <div class="anonymous" v-else>
        <el-avatar icon="el-icon-user" :src="info.amAvatarUrl"></el-avatar>
        <div class="text">
          <p>
            <span>昵称</span>
            <span>【匿名】{{ propInfo.name }}</span>
          </p>
          <p>
            <span>性别</span>
            <span v-if="sex === 1">男</span>
            <span v-else-if="sex === 2">女</span>
            <span v-else>未设置</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import User from "@/api/user";
export default {
  data() {
    return {
      editing: false,
      sex: 0,
      nickName: "",
      info: {
        id: "",
        company: "",
        companyId: "",
        avatar: "",
        name: "",
        nickName: ""
      },
      companyInfo: {
        companyName: "",
        address: "",
        phone: "",
        email: "",
        telephone: "",
        qq: "",
        contact: "",
        intro: "",
        otherLabels: [],
        labels: [],
        contacts: []
      },
      loading: false
    };
  },
  computed: {
    ...mapState({
      userId: state => state.userId
    }),
    isMine() {
      return this.id === this.userId;
    },
    isAnonymous() {
      return this.propInfo.isAnonymous || false;
    },
    id() {
      return this.propInfo.id || this.propInfo.userId;
    }
  },
  props: {
    propInfo: Object
  },
  methods: {
    link() {
      this.$router.push({
        path: "/company",
        query: {
          id: this.info.companyId,
          name: this.info.company
        }
      });
    },
    setSex(value) {
      this.sex = this.sex === value ? 0 : value;
    },
    async privateChat() {
      this.$store.commit("setChatScroll");
      const result = await $.connection.chatConversationHub.server.createConversation(this.info.id);
      const data = {
        id: result.conversationId,
        company: result.company,
        name: result.name,
        userId: result.id
      };
      this.$router.push({
        path: "/conversation",
        query: data
      });
    },
    async save() {
      this.loading = true;
      await User.updateInfo({ nickName: this.nickName, sex: this.sex }).then(() => {
        this.$toast.success("保存成功");
        this.$store.commit("updateUserInfo", { nickName: this.nickName, sex: this.sex });
        this.editing = false;
        this.loading = false;
      });
      await User.info(this.id).then(res => {
        this.nickName = res.NickName;
        this.sex = res.Sex || 0;
        this.info = {
          id: res.UserGuid,
          company: res.CompanyName,
          companyId: res.CompanyId,
          avatar: res.UserAvatarUrl,
          amAvatarUrl: res.AMAvatarUrl,
          name: res.UserName,
          nickName: res.NickName
        };
      });
    },
    async getUserInfo() {
      this.loading = true;
      await User.info(this.id).then(res => {
        this.nickName = res.NickName;
        this.sex = res.Sex || 0;
        this.info = {
          id: res.UserGuid,
          company: res.CompanyName,
          companyId: res.CompanyId,
          avatar: res.UserAvatarUrl,
          amAvatarUrl: res.AMAvatarUrl,
          name: res.UserName,
          nickName: res.NickName
        };
      });
      await User.companyDetail(this.info.companyId, this.info.company).then(response => {
        const data = response;
        const labels = [];
        const otherLabels = [];
        const contacts = [];
        data.Labels &&
          data.Labels.map(item => {
            const data = { label: item.Label, qty: item.Qty };
            item.IsMine ? otherLabels.push(data) : labels.push(data);
          });
        data.Contacts &&
          data.Contacts.map(item => {
            if (item.NumberType === 1) {
              contacts.push({
                number: item.Number,
                isDefault: item.IsDefault,
                contact: item.Contact
              });
            }
          });
        this.companyInfo = {
          companyName: data.CompanyName,
          address: data.Address,
          phone: data.Phone,
          email: data.Email,
          isHideLabel: data.IsHideLabel,
          telephone: data.Telephone,
          qq: data.QQ,
          intro: data.Introduction,
          contact: data.Contact,
          labels,
          otherLabels,
          contacts
        };
      });
      this.loading = false;
    }
  },
  mounted() {
    this.getUserInfo();
  }
};
</script>
<style lang="scss">
.info-dialog {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
  }
}
.m-userinfo-dialog {
  position: relative;
  .container > div {
    display: flex;
    box-sizing: border-box;
    padding: 10px;
    position: relative;
    .right {
      position: absolute;
      right: 20px;
      cursor: pointer;
    }
    .text {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 10px;
      p > span:first-child {
        margin-right: 10px;
      }
      span {
        display: inline-block;
        white-space: nowrap;
      }
    }
  }
  .anonymous {
    background-color: #eee;
    .edit-btn {
      color: #409eff;
      cursor: pointer;
    }
    &,
    .anonymous {
      p {
        display: flex;
        align-items: center;
      }
    }
    .el-checkbox {
      margin: 0px 10px 0 5px;
    }
    .el-checkbox__label {
      padding-left: 5px;
    }
  }
  .real {
    flex-wrap: wrap;
    .el-divider {
      margin: 20px 0 0 0;
    }
  }
  .text-btn {
    cursor: pointer;
    color: #409eff;
    white-space: nowrap;
    font-size: 12px;
  }
  .editing {
    input {
      width: 100px;
    }
  }
  .tags-box {
    display: flex;
    flex-direction: column;
    .green-tags {
      margin-bottom: 5px;
      .tag {
        background: #15992b;
      }
    }
    .empty-text {
      margin-top: 15px;
      font-size: 12px;
      color: #b3b3b3;
    }
    .orange-tags {
      .tag {
        background: #ef8216;
      }
    }
    .promise {
      padding-left: 10px;
      color: #808080;
    }
    .tag {
      padding: 2px 4px;
      border-radius: 2px;
      color: #fff;
      font-size: 12px;
      margin-right: 4px;
    }
  }
  .more {
    display: flex;
    justify-content: center;
    span {
      font-size: 14px;
    }
  }
  .company {
    display: flex;
    flex-direction: column;
    .name {
      color: #000;
      font-size: 16px;
    }
    p {
      display: flex;
      margin-bottom: 5px;
      span {
        display: inline-block;
        min-width: 50px;
      }
    }
  }
}
</style>
